import { TmdxResourceCard } from '@features/components/ResourceCards';
import { CaseClinicalSpecialistResource, CaseResource, CaseRetrievalSurgeonResource } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';
import { RESOURCE_STATUS_TEXT_MAP } from '@/constants/resources.constants';

type CaseLogisticsEmployeeInfoProps = {
  employee: CaseResource<CaseClinicalSpecialistResource | CaseRetrievalSurgeonResource>;
  subTitle: string;
};

export const CaseLogisticsEmployeeInfo = ({ employee, subTitle }: CaseLogisticsEmployeeInfoProps) => (
  <TmdxResourceCard
    size="sm"
    label="Actions"
    list={[]}
    type="user"
    title={getFullName(employee.data?.firstName, employee.data?.lastName)}
    subTitle={subTitle}
    cardClassNames="min-w-full"
    avatarProps={{
      type: 'user',
      src: employee.data?.profilePhoto,
    }}
    chipProps={{
      status: employee.logisticsStatus,
    }}
    chipText={RESOURCE_STATUS_TEXT_MAP[employee.logisticsStatus]}
    isReadOnly
    menuDisabled
  />
);
